import { EntitysSelectors } from "@shared/src/enums/EntitysSelectors";
import { EntitySelectorDto } from "../EntitySelectorDto";

export class QuestionEntitySelectorDto extends EntitySelectorDto {

	public static new(activeFilterKeys: Array<String>): QuestionEntitySelectorDto {
		let result: QuestionEntitySelectorDto = new QuestionEntitySelectorDto();
		result.loadData(EntitysSelectors.Question, "", activeFilterKeys, 0, false);
		return result;
	}

	public getUrlGoToMaintenance(): string {
		return "system/screensandforms/formquestion";
	}

	public getUrlBack(): string {
		return "/maintenance/question";
	}

}